export interface ProductLine {
  productLineId: number;
  productLineCode: string;
  productLineDesc: string;
}

export interface ProductLineV1 {
  productLineId: number;
  productLineCode: string;
  productLineDesc: string;
  businessLine: {
    businessLineId: number
    businessLineCode: string
  };
}
